export default function getPageCount(total, limit) {
  return total % limit === 0 ? total / limit : Math.floor(total / limit) + 1;
}
